import {CryptoHolding} from '@/integrations/supabase/crypto.models.ts';

/**
 * Groups holdings by symbol and computes aggregated totals.
 */
export function computeCryptoHoldingsAggregation(holdings: CryptoHolding[]): AggregatedCryptoHolding[] {
    const map = new Map<string, AggregatedCryptoHolding>();

    for (const h of holdings) {
        const existing = map.get(h.symbol);
        if (existing) {
            existing.totalAmount += h.amount;
            existing.totalCostBasis += h.cost_basis;
            if (!existing.walletIds.includes(h.wallet_id)) {
                existing.walletIds.push(h.wallet_id);
                existing.walletCount = existing.walletIds.length;
            }
        } else {
            map.set(h.symbol, {
                symbol: h.symbol,
                name: h.name,
                totalAmount: h.amount,
                totalCostBasis: h.cost_basis,
                walletCount: 1,
                walletIds: [h.wallet_id],
            });
        }
    }

    return Array.from(map.values());
}
